import { Grid, Text, Box, TextProps } from "@chakra-ui/react";
import { usePropertyFields } from "../providers/property-fields-context";
import { PropertySectionKind } from "../types/property-section.view-model";

const titleStyles: Record<PropertySectionKind, TextProps> = {
  section: {
    fontWeight: "bold",
    fontSize: "lg",
    mb: 2,
    color: "primary.500",
  },
  security: {
    fontSize: "md",
    fontWeight: "semibold",
    mb: 2,
    color: "cyan.800",
  },
  unit: {
    fontSize: "md",
    fontWeight: "semibold",
    mb: 2,
    color: "gray.200",
  },
};

type PropertyFieldSectionProps = {
  title: string;
  kind: PropertySectionKind;
  children: React.ReactNode;
};

export function PropertyFieldSection({ title, kind, children }: PropertyFieldSectionProps) {
  const { isEditing } = usePropertyFields();

  return (
    <Box width="100%">
      <Text {...titleStyles[kind]}>{title}</Text>
      <Grid
        templateColumns={{
          base: "1fr",
          md: "repeat(2, 1fr)",
        }}
        columnGap={4}
        rowGap={isEditing ? 4 : 0}
        mt={4}
      >
        {children}
      </Grid>
    </Box>
  );
}
